export default {
    setEvents(state, events) {
        state.events = events;
    },
    setNotes(state, notes) {
        state.notes = notes;
    },
    setQbToken(state, token) {
        state.qbToken = token;
    },
    setQbRefreshToken(state, token) {
        state.qbRefreshToken = token;
    },
    setManageEventDialog(state, status) {
        state.manageEventDialog = status;
    },
    setManageNoteDialog(state, status) {
        state.manageNoteDialog = status;
    }
}
